<template>
    <div class="class-edit">
        <div class="breadcrumb">班级班级
            <el-button class="right_f" type="primary" @click="save">保存</el-button>
            <el-button class="right_f" type="primary" @click="cancel">取消</el-button>
        </div>

        <div>
            <el-form ref="form" :rules="rules" :model="form" label-width="130px">
                <el-form-item label="账号:" prop="username">
                    <el-input v-model="form.username" class="label-width" placeholder="请填写正确的账号" disabled></el-input>
                </el-form-item>
                <el-form-item label="昵称:" prop="showName">
                    <el-input v-model="form.showName" class="label-width" placeholder="请填写正确的昵称" disabled></el-input>
                </el-form-item>
                <el-form-item label="行政班级:">
                    <el-checkbox-group v-model="isCheckAll" @change="checkAll">
                        <el-checkbox label="true">全选</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="" prop="departs">
                    <el-checkbox-group v-model="form.departs" style="width:50%;">
                        <el-checkbox v-for="item in departs" :label="item.id" value="item.id" :key='item.id'>{{item.department}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        data() {
            return {
                departs: [],
                isCheckAll: false,
                form: {
                    username: "",
                    showName: "",
                    departs: []
                },
                rules: {

                }
            }
        },
        mounted() {
            this.getAllDepart();
        },
        methods: {
            //全选与取消全选
            checkAll(val) {
                this.form.departs = val ? this.departs.map(item => item.id) : [];
            },
            //获取某个学校之下的所有院系;
            getAllDepart() {
                let url = this.$util.domain + "/adminapi/v1/campus/schoolAdmin/v2/getDepartments";

                this.$http({
                    url,
                    method: 'GET',
                    params: {
                        rootUnid: this.$util.getUrlParam("rootUnid")
                    }
                }).then(response => {
                    if (response.data.error == 10000) {
                        let list = response.data.data;
                        list.forEach(item => {
                            this.departs.push({
                                id: item.id + "",
                                department: item.department
                            })
                        })

                        this.getDet();
                    }
                })
            },
            //获取详情
            getDet() {
                let url = this.$util.domain + "/adminapi/v1/campus/schoolAdmin/v2/getManageClass";

                this.$http({
                    url,
                    method: "GET",
                    params: {
                        username: this.$util.getUrlParam("username")
                    }
                }).then(response => {
                    if (response.data.error == 10000) {
                        let dataObj = response.data.data;
                        if (dataObj.departments.length == this.departs.length) {
                            this.isCheckAll = true;
                        }
                        this.form = {
                            username: dataObj.username,
                            showName: dataObj.nick,
                            departs: dataObj.departments.map(item => item.id + "")
                        }
                    } else {
                        this.$util.errorMsg(response.data.message);
                    }
                })
            },
            save() {
                let url = this.$util.domain + "/adminapi/v1/campus/schoolAdmin/v2/addOrEdit";

                this.$http({
                    url,
                    method: "POST",
                    body: JSON.stringify({
                        rootUnid: this.$util.getUrlParam("rootUnid"),
                        username: this.$util.getUrlParam("username"),
                        actionType: 3,//新增或者修改1，新增，2，修改,3，修改班级
                        roleType: 5, //2-学校管理员 4-场馆管理员 5-班级管理员
                        departmentIds: this.form.departs.map(item => item * 1)
                    })
                }).then(response => {
                    if (response.data.error == 10000) {
                        this.$util.successMsg('保存成功');
                        this.cancel();
                    } else {
                        this.$util.errorMsg(response.data.message);
                    }
                })

            },
            cancel() {
                let url = location.href;
                location.href = url.replace("editClass", "Manager");
            }
        }
    };
</script>


<style>
    .label-width {
        width: 25%;
        min-width: 250px;
    }
</style>


// WEBPACK FOOTER //
// editClass.vue?7f2a364b